export default __webpack_public_path__ + "assets/images/582e8c7846cf8926f6aeecc053eaddc6.svg";